import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {PrlAuthenticationService} from "./prl-authentication.service";
import {
    PrlTermsAndConditionsPageService
} from "../../view/prl-authentication/services/terms-and-conditions-page/prl-terms-and-conditions-page.service";
import {Router} from "@angular/router";

@Injectable()
export class PrlBasicAuthHttpInterceptorService implements HttpInterceptor {

    private BAD_CREDENTIALS = 'bad.credentials.error';

    constructor(
        private authService: PrlAuthenticationService,
        private router: Router,
        private prlTermsAndConditionsPageService: PrlTermsAndConditionsPageService
    ) {
    }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let httpHeaders = req.headers.set('X-Requested-With', 'XMLHttpRequest');


        const isPublicRequest = req.url.startsWith('/rest/languages');

        if (this.authService.token && !isPublicRequest) {
            httpHeaders = httpHeaders.set('X-Auth-token', this.authService.token);
        }

        const clonedRequest =
            req.clone(
                {
                    withCredentials: true,
                    headers: httpHeaders
                }
            );

        return next.handle(clonedRequest)
            .pipe(
                catchError(error => {
                    if (error.status === 429) {
                        this.authService.invalidateAuth(error.error);
                        return of(error.message);
                    }
                    if (error.status === 401) {
                        this.authService.invalidateAuth(this.BAD_CREDENTIALS);
                        return of(error.message);
                    }
                    if (error.status === 403) {
                        return this.prlTermsAndConditionsPageService.setIsTcAccepted().pipe(
                            switchMap(isTcAccepted => {
                                if (!isTcAccepted) {
                                    this.router.navigateByUrl('/terms');
                                    return EMPTY;
                                }
                                return throwError(error);
                            })
                        );
                    }
                    return throwError(error);
                }));
    }

}
